'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var HUMAN = exports.HUMAN = 'human';
var BOT = exports.BOT = 'bot';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/constants/AgentTypes.js
// module id = 202
// module chunks = 0 1